export const environment = {
    apiUrl: window.location.protocol + "//" + window.location.host,
    production: true,
    cookieDomain: 'localhost',
    enableTracing : false,
};
